"use client";
import { useTranslations } from "next-intl";
import { CatButton } from "components/blocks-components";
import {
  EquipmentMoreAction,
  EquipmentActionCard,
  EquipmentMoreActionList,
  EquipmentMoreActionListItem,
} from "@cat-ecom/pcc-components";
import { actionTypes } from "../types";
import EquipmentActionsIconCard from "./equipment-actions-icon-card";
import { MY_EQUIP_GA_EVENTS } from "../constants";
import styles from "./my-equipment-action-menu.module.scss";

export interface EquipmentMoreActionProp {
  cardAction: actionTypes;
}

const EquipmentMoreActionLayout = ({
  cardAction,
}: Readonly<EquipmentMoreActionProp>) => {
  const t = useTranslations();

  return (
    <>
      {!cardAction.moreOptions ? (
        <EquipmentActionCard
          classname={styles["equipment-actions--card"]}
          onClick={cardAction.onClick}
          data-track-event={MY_EQUIP_GA_EVENTS.PRIMARY_CTA}
          data-track-attr-nltext={cardAction.gaLabel}
          data-track-attr-context={cardAction.gaContext}
        >
          <EquipmentActionsIconCard
            id={cardAction.id}
            icon={cardAction.icon}
            label={cardAction.label}
            classname={cardAction.classNames}
          />
        </EquipmentActionCard>
      ) : (
        <EquipmentMoreAction>
          <>
            <CatButton
              className={styles["equipment-actions--more-button"]}
              slot="trigger"
              variant="ghost"
              data-track-event={MY_EQUIP_GA_EVENTS.PRIMARY_CTA}
              data-track-attr-nltext={cardAction.gaLabel}
              data-track-attr-context={cardAction.gaContext}
            >
              <EquipmentActionsIconCard
                id={cardAction.id}
                icon={cardAction.icon}
                label={cardAction.label}
                classname={cardAction.classNames}
              />
            </CatButton>
            <div className={styles["contextual-menu-width"]}>
              <EquipmentMoreActionList>
                <>
                  {cardAction.moreOptions
                    ?.filter((row) => row.isActionVisible)
                    .map((moreAction) => {
                      return (
                        <EquipmentMoreActionListItem
                          key={moreAction.id}
                          onSelect={() => moreAction?.onClick()}
                          classNames={moreAction?.classNames}
                        >
                          <div
                            data-track-event={MY_EQUIP_GA_EVENTS.PRIMARY_CTA}
                            data-track-attr-nltext={moreAction.gaLabel}
                            data-track-attr-context={moreAction.gaContext}
                          >
                            {t(moreAction.label)}
                          </div>
                        </EquipmentMoreActionListItem>
                      );
                    })}
                </>
              </EquipmentMoreActionList>
            </div>
          </>
        </EquipmentMoreAction>
      )}
    </>
  );
};

export default EquipmentMoreActionLayout;
